<template>
  <FenFa/>
</template>

<script>
import FenFa from './components/FenFa.vue'

export default {
  name: 'App',
  components: {
    FenFa
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>
